<template>
    <div class="o-numbers-keyboard">
        <button
            v-for="keyboard in KEYBOARD_KEYS"
            :key="keyboard"
            type="button"
            class="numbers-keyboard-button"
            @click="onClick(keyboard)"
        >
            {{ keyboard }}
        </button>
    </div>
</template>

<script>
import { KEYBOARD_KEYS } from './constants';

export default {
    name: 'ONumbersKeyboard',
    setup(props, { emit }) {
        function onClick(data) {
            emit('onClick', data);
        }

        return {
            KEYBOARD_KEYS,
            onClick
        };
    }
}
</script>

<style lang="scss" src="./theme.scss" />